import React, { useEffect, useState } from "react";
import {useHistory} from "react-router-dom";
import {connect} from "react-redux";
import map from "lodash/map";
import orderBy from "lodash/orderBy";
import moment from "moment";
import styles from "./EventsList.scss";
import Calendar from "components/site/elements/Calendar";
import EventTypeTile from "components/site/elements/EventTypeTile";
import EventCard from "components/site/elements/EventCard";
import Loader from "components/shared/elements/Loader";
import * as SiteActions from "actions/SiteActions";

function EventsList(props) {
    const history = useHistory();

    useEffect(() => {
        props.loadEventTypes();
    }, []);

    const renderEvents = () => {
        return map(orderBy(props.eventTypes, ["order"], ["asc"]), (event, indx) => (
            <EventTypeTile
                event={event}
                key={`event_${indx}`}
            />
        ));
    }

    const renderUpcomingEvents = () => {
        const next5 = map(props.events).slice(0,5);
        return map(next5, (event, indx) => (
            <EventCard event={event} key={`event_${indx}`} sidebar />
        ));
    }

    const handleCalendarClick = (calendarDate) => {
        history.push(`/calendar/${moment(calendarDate).format("YYYY-MM-DD")}`)
    }

    if (!props.eventTypes) {
        return <Loader />
    }

    return (
        <div className={styles.root}>
            <div className={styles.content}>
                <div className={styles.mainContainer}>
                    <h2>JazzWire Sessions</h2>
                    <p className={styles.summary}>The JAZZWIRE SESSIONS are a series of online & offline services that will help you learn, play and share jazz music. Each session, whether online or in-person, is led by our talented and inspiring jazz coach/performers and features exclusive audio and video content, individual coach-to-player direct feedback, pdf lesson packs, workshop recordings and much more. Plus, you'll be part of a highly engaged community of adult learners like yourself who share a passion for jazz improvisation. Check out each of our offerings below!</p>
                    <div className={styles.groupsContainer}>
                        {renderEvents()}
                    </div>
                </div>
                <div className={styles.sidebarContent}>
                    <div className={styles.sidebarInner}>
                        <div className={styles.topText}>
                            <h4>Calendar of Events</h4>
                        </div>
                        <Calendar
                            onClick={handleCalendarClick}
                        />
                        <div className={styles.eventsContainer}>
                            {renderUpcomingEvents()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

EventsList.propTypes = {};

export default connect(
    (state) => ({
        events: orderBy(state.site.events, ["eventDate"], ["asc"]),
        eventTypes: state.site.eventTypes,
    }),
    (dispatch) => ({
        loadEventTypes: () => dispatch(SiteActions.loadEventTypes()),
    })
)(EventsList);
